import { c as _c } from "react/compiler-runtime";
import { useNumberFormatter } from "@opensea/i18n";
import { ImageStack, Toast, ToastAvatar, ToastContent, ToastDescription, ToastErrorIcon, ToastSide, ToastSuccessIcon, ToastTitle } from "@opensea/ui-kit";
import { Sell } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { Avatar } from "../../../components/Avatar";
import { useRenderImage } from "../../../providers/RenderImageProvider";
export const CreateListingToast = t0 => {
  const $ = _c(16);
  const {
    imageUrls,
    price,
    success
  } = t0;
  const t = useTranslations("wallet.CreateListingToast");
  const {
    renderImage
  } = useRenderImage();
  const format = useNumberFormatter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Avatar.Badge><Sell size={12} /></Avatar.Badge>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const badge = t1;
  let t2;
  if ($[1] !== imageUrls || $[2] !== renderImage) {
    t2 = imageUrls.length === 1 ? <ToastAvatar badge={badge} renderImage={renderImage} src={imageUrls[0] || ""} /> : <ImageStack overrides={{
      Avatar: {
        position: {
          center: {
            className: "rounded",
            renderImage,
            badge
          },
          right: {
            className: "rounded"
          }
        }
      }
    }} size={44} srcs={imageUrls.slice(0, 2).map(_temp)} />;
    $[1] = imageUrls;
    $[2] = renderImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== format || $[5] !== imageUrls.length || $[6] !== price || $[7] !== success || $[8] !== t) {
    t3 = <ToastContent>{success ? <><ToastTitle>{t("title", {
            count: imageUrls.length
          })}</ToastTitle>{imageUrls.length === 1 ? <ToastDescription>{format(price.unit, {
            display: "full",
            suffix: price.symbol
          })}</ToastDescription> : null}</> : <ToastTitle>{t("failedTitle")}</ToastTitle>}</ToastContent>;
    $[4] = format;
    $[5] = imageUrls.length;
    $[6] = price;
    $[7] = success;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== success) {
    t4 = <ToastSide>{success ? <ToastSuccessIcon /> : <ToastErrorIcon />}</ToastSide>;
    $[10] = success;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Toast>{t2}{t3}{t4}</Toast>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp(imageUrl) {
  return imageUrl || "";
}